import { createSlice } from "../helper";
import upcomingConversationWidgetReducers from "../reducers/homePage/upcomingConversationWidgetReducers";

const homePageSlice = createSlice({
  name: 'homePage',
  initialState: {
    upcomingConversationWidget: {
      reloadWidget: false,
      showLoader: false
    },
    connectionTabs: {}
  },
  reducers: {
    ...upcomingConversationWidgetReducers,
    setConnectionTabsData: (state, action) => {
      state.connectionTabs = action.payload;
    },
    updateConnectionTab: (state, action) => {
      const { groupId, formattedNextMeetingTime } = action.payload;
      state.connectionTabs[groupId] = formattedNextMeetingTime;
    }
  }
});

export const homePageActions = homePageSlice.actions;
export default homePageSlice;
